module.exports = __webpack_public_path__ + "01_short_brown.84be7ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_short_brown.png
// module id = t8Ae
// module chunks = 0